import './Stats.scss';

import React from 'react';
import { Bar } from 'react-chartjs-2';
import { React as Selectivity } from 'selectivity/react';
import Select from 'react-select'
import {SelectStyle, DropdownIndicator} from '../App/select_style'
import DatePicker, { registerLocale } from "react-datepicker";
import hu from 'date-fns/locale/hu'
registerLocale('hu', hu)

import Frame from '../Frame/Frame';
import { STORE_STATS } from '../../Store/StatsStore';
import { observer, inject } from 'mobx-react';
import { STORE_CONFIG } from '../../Store/ConfigStore';

@inject(stores => ({
  store: stores.store.get(STORE_STATS),
  configStore: stores.store.get(STORE_CONFIG),
  socket: stores.socket
}))
@observer
class Stats extends React.Component {
  refresh = () => {
    const { store, socket } = this.props;
    if (store.from && store.to) {
      const request = {
        "From": store.fromFormatted,
        "To": store.toFormatted
      };
      if (store.itemId) {
        request.ItemId = store.itemId;
      }
      socket.emitWithToken('GetStatsData', request, (err, data) => {
        if (err) {
          console.error(err);
          return;
        }
        store.setItems(data);
      });
    }
  };
  componentDidMount() {
    this.refresh();
  }
  render() {
    const { store, configStore } = this.props;
    return <Frame>
      <div className="stats">
        <div className="stats__display">
          <Bar options={{
            scales: {
              yAxes: [{
                ticks: {
                  min: 0,
                  fontColor: '#fff',
                  callback: function (value, index, values) {
                    return value + ' t';
                  }
                },
                scaleLabel: {
                  display: true,
                  labelString: ' Raktárkészlet',
                  fontSize: 15,
                  fontColor: '#ffa81d'
                }
              }],
              xAxes: [{
                ticks: {
                  fontColor: '#fff',
                  minRotation: 45
                },
                type: 'time',
                time: {
                  unit: 'day',
                  displayFormats: {
                    day: 'YYYY.MM.DD'
                  }
                },
                distribution: 'series'
              }]
            },
            tooltips: {
              callbacks: {
                beforeLabel: function (tooltipItem, data) {
                  return null;
                },
                label: function (tooltipItem, data) {
                  return tooltipItem.yLabel + ' tonna'
                }
              },
              displayColors: false
            }
          }} legend={{
            display: false
          }} data={{
            labels: Object.keys(store.items),
            datasets: [{
              backgroundColor: '#ffba2a',
              data: Object.values(store.items).map(item => { return (item / 1000) })
            }]
          }} />
        </div>
        <div className="stats__sidebar">
          <div className="stats__input-row form-row">
            <div className="stats__input-label form-label">Kezdés dátuma</div>
            <DatePicker className="stats input-date form-input" dateFormat="yyyy-MM-dd" selected={store.from} onChange={date => { store.setFrom(date); this.refresh(); }} /*locale='hu'*/ />
          </div>
          <div className="stats__input-row form-row">
            <div className="stats__input-label form-label">Befejezés dátuma</div>
            <DatePicker className="stats input-date form-input" dateFormat="yyyy-MM-dd" selected={store.to} onChange={date => { store.setTo(date); this.refresh(); }} /*locale='hu'*/ />
          </div>
          <div className="stats__input-row form-row item">
            <div className="stats__input-label form-label">Cikkszám</div>
            {/*<Selectivity
              className="stats__input-select"
              allowClear={true}
              placeholder="Összes"
              value={store.itemId}
              items={Object.entries(configStore.items).map(([id, text]) => ({ id, text }))}
              onChange={e => { store.setItemId(e.value); this.refresh(); }}
              dropdownCssClass='select_dropdown'
            />*/}
            <Select
              className='react-select'
              placeholder="Összes"
              options={Object.entries(configStore.items).map(([id, text]) => ({ value: id, label: text }))}
              onChange={e => { store.setItemId((e ? e.map(item => item.value) : null)); this.refresh(); }}
              isClearable={true}
              isSearchable={true}
              isMulti={true}
              styles={SelectStyle}
              components={{ DropdownIndicator }}
            />
          </div>
        </div>
      </div>
    </Frame>;
  }
}

export default Stats;